import {Injectable} from '@angular/core';
import {ToastController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class ToastService {

    constructor(
        private toastController: ToastController,
        private translate: TranslateService,
    ) {
    }

    create(type, message) {
        return this.toastController.create({
            message: this.translate.instant(message),
            position: 'middle',
            cssClass: ['toast', 'toast-'+type],
            duration: 2000
        }).then((toast) => {
            return toast.present()
                .then(_ => toast);
        })
    }

}
